<template>
  <audio
    controls="controls"
    hidden
    src="@/assets/sounds/notify.wav"
    ref="audio"
  ></audio>
</template>

<script>
import { userNotifyGet } from "../api";

export default {
  data: function () {
    return {
      userConfig: null,
      userNotifys: [],
      timer: null,
      isClickNotifyLink: false,
    };
  },
  mounted() {
    this.openIntervalGetNotify();
    window.goTo = this.goTo;
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  destroyed() {},
  methods: {
    playNotifySound() {
      this.$refs.audio.currentTime = 0;
      this.$refs.audio.play();
    },
    openIntervalGetNotify() {
      // console.log("openIntervalGetStat");
      this.getNotify();
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(this.getNotify, 20000);
    },
    getNotify() {
      if (
        this.$store.state.configInfo.notify.isOpenNotify == null ||
        this.$store.state.configInfo.notify.isOpenNotify == false
      ) {
        return;
      }
      userNotifyGet({})
        .then((res) => {
          this.userNotifys = res.data.notifyInfoList;
          if (
            this.userNotifys.length > 0 &&
            this.$store.state.configInfo.notify.isOpenNotifySound == true
          ) {
            this.playNotifySound();
          }
          this.userNotifys.forEach((item) => {
            let parent = this;
            let notifyObj = this.$notify({
              dangerouslyUseHTMLString: true,
              title: item.title,
              message:
                "<span>" +
                item.createDate +
                "<span><br/><a onclick=\"goTo('" +
                item.link +
                "')\">" +
                item.message +
                "</a>",
              type: item.type,
              showClose: item.showClose,
              position: item.position,
              duration: item.duration,
              onClick: function () {
                // 等待400ms，如果判断到点击了链接的话，则关闭该提示窗
                setTimeout(() => {
                  if (parent.isClickNotifyLink == true) {
                    parent.isClickNotifyLink = false;
                    this.close();
                  }
                }, 400);
              },
            });
          });
          // console.log(this.cascaderValue)
        })
        .catch((err) => {});
    },
    goTo(link) {
      this.isClickNotifyLink = true;
      if (link == this.$route.path) {
        // 当前处于同一页面，不用跳转了
        return;
      }
      this.$router.push({ path: link });
    },
  },
};
</script>

<style scoped>
</style>
